import { analitics } from "../common/functions/loginWithFunction";

export const GAeventSearch = (q) => {
  analitics.logEvent("search_query", { query: q });
};
